export default {
  contact_support: "contact {support} ",
  text1:
    "The app is unable to access the internet. Offline mode can first be used after the app has downloaded what it needs from a Workspace.",
  text2:
    "Please try the usual internet-troubleshooting steps: Connected to mobile network/WiFi, the router is on, etc. and try again.",
  text3: "If you are certain your device can access the internet, please ",
  title: "Offline!",
  quote: "I don’t know about this new-fangled “Internet” fad... I’ll give it 6 months",
}
